import React from "react";
import { AppBar, Box, Button, Drawer, IconButton, List, ListItemButton, Toolbar, Typography } from "@mui/material";
import { MenuRounded } from "@mui/icons-material";
import { Bio } from "../../data/constants";

const links = [
  { label: "SYS_ABOUT", href: "#about" },
  { label: "INTEL_LOG", href: "#skills" },
  { label: "OPS_RECORD", href: "#experience" },
  { label: "EVIDENCE", href: "#projects" },
];

const Navbar = () => {
  const [drawer, setDrawer] = React.useState(false);

  return (
    <>
      <AppBar position="fixed" elevation={0} color="transparent" sx={{
        top: "auto", bottom: { xs: 0, md: 32 }, left: 0, right: 0,
        alignItems: "center", pointerEvents: "none", zIndex: 100,
      }}>
        <Toolbar disableGutters sx={{ justifyContent: "center", pointerEvents: "auto" }}>
          <Box className="tactical-border cyber-clip" sx={{
            display: { xs: "none", md: "flex" }, alignItems: "center", gap: 3,
            px: 3, py: 1.5, bgcolor: "rgba(5, 8, 18, 0.95)", backdropFilter: "blur(10px)",
          }}>
            {links.map((l) => (
              <Box key={l.href} component="a" href={l.href} sx={{
                color: "#858d99", fontSize: "0.75rem", textDecoration: "none",
                fontFamily: "'JetBrains Mono', monospace", letterSpacing: "0.1em",
                transition: "all 0.2s ease",
                "&:hover": { color: "#00f0ff", textShadow: "0 0 10px rgba(0,240,255,0.4)" },
              }}>
                {l.label}
              </Box>
            ))}
            <Box sx={{ width: 1, height: 16, bgcolor: "rgba(0, 240, 255, 0.2)" }} />
            <Box component="a" href={Bio.resume} target="_blank" className="sys-glitch" sx={{
              color: "#00f0ff", fontSize: "0.75rem", textDecoration: "none",
              fontFamily: "'JetBrains Mono', monospace", letterSpacing: "0.1em",
              animation: "neonPulse 2s infinite alternate",
            }}>
              [DOWNLOAD_DOSSIER]
            </Box>
          </Box>

          {/* Mobile */}
          <Box className="tactical-border" sx={{
            display: { xs: "flex", md: "none" }, width: "100%", justifyContent: "space-between",
            p: 1.5, bgcolor: "rgba(2, 4, 10, 0.95)",
          }}>
            <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", color: "#00f0ff", fontSize: "0.7rem", pt: 1 }}>
              SYS_ACTIVE
            </Typography>
            <IconButton onClick={() => setDrawer(true)} sx={{ color: "#00f0ff", p: 0.5 }}>
              <MenuRounded />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      <Drawer anchor="bottom" open={drawer} onClose={() => setDrawer(false)}
        PaperProps={{ sx: { bgcolor: "#02040a", borderTop: "1px solid rgba(0, 240, 255, 0.2)" } }}>
        <Box sx={{ p: 3 }}>
          <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", color: "#00f0ff", mb: 2, fontSize: "0.8rem" }}>
            {"//"} NAVIGATION_MENU
          </Typography>
          <List>
            {links.map((l) => (
              <ListItemButton key={l.href} component="a" href={l.href} onClick={() => setDrawer(false)}
                sx={{ borderBottom: "1px solid rgba(0, 240, 255, 0.1)", py: 1.5 }}>
                <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", color: "#e6e8ec", fontSize: "0.75rem" }}>
                  {l.label}
                </Typography>
              </ListItemButton>
            ))}
            <ListItemButton component="a" href={Bio.resume} target="_blank" sx={{ py: 1.5 }}>
              <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", color: "#00f0ff", fontSize: "0.75rem" }}>
                [DOWNLOAD_DOSSIER]
              </Typography>
            </ListItemButton>
          </List>
        </Box>
      </Drawer>

      {/* Sticky Bottom Right Contact (from Reference) */}
      <Button href="#contact" sx={{
        position: "fixed", bottom: { xs: 80, md: 32 }, right: 32, zIndex: 100,
        bgcolor: "#02040a", border: "1px solid rgba(0, 240, 255, 0.3)",
        borderRadius: 99, px: 2, py: 0.5,
        "&:hover": { borderColor: "#00f0ff", bgcolor: "rgba(0, 240, 255, 0.05)" }
      }}>
        <Box sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: "#00f0ff", mr: 1, animation: "blink 2s steps(1) infinite" }} />
        CONTACT_ME
      </Button>
    </>
  );
};

export default Navbar;
